import { messages } from 'helpers/validationMessages'
import * as yup from 'yup'

import { User } from '../types'

export const editUserFormSchema = yup.object().shape({
  firstname: yup
    .string()
    .required(messages.required)
    .max(100, messages.maxLength(100))
    .test('notOnlySpaces', messages.required, value => value.trim() !== ''),
  lastname: yup
    .string()
    .required(messages.required)
    .max(100, messages.maxLength(100))
    .test('notOnlySpaces', messages.required, value => value.trim() !== ''),
  middlename: yup.string().max(100, messages.maxLength(100)),
})

export const editUserFormDefaultValues = (data: User | undefined) => {
  return {
    firstname: data?.firstName || '',
    lastname: data?.lastName || '',
    middlename: data?.fatherName || '',
    address: data?.customerAddress || {
      value: '',
      fiasId: '',
      fiasLevel: '',
    },
    personalAgree: true,
  }
}

export const editUserFormDefaultValuesForReset = (data: User | undefined) => {
  return {
    firstname: data?.firstName || '',
    lastname: data?.lastName || '',
    middlename: data?.fatherName || '',
    address: {
      address: data?.customerAddress.address || '',
      fiasId: data?.customerAddress.fiasId || '',
      fiasLevel: data?.customerAddress.fiasLevel || '',
      geoLat: data?.customerAddress.geoLat || '',
      geoLon: data?.customerAddress.geoLon || '',
    },
    personalAgree: true,
  }
}
